import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import styles from './Band.module.css';

const Band = () => {
  const {
    bandAuthorName,
    bandGuideTitle,
    bandBackgroundColor: backgroundColor,
  } = useSearchParamOrDefaultProps();

  return (
    <div className={styles.bandWrapper} style={{ backgroundColor }}>
      <div className={styles.bandTitle}>
        {bandAuthorName}
        <span>{bandGuideTitle}</span>
      </div>
    </div>
  );
};

Band.displayName = 'Band';

export default Band;
